import axios from "axios";

const apiService=axios.create({
  baseURL: "https://ds5testerapp.com/api",
  //baseURL: "http://localhost:4000/",
})

export default apiService;